<template>
  <div class="box">
    <table>
      <tr>
        <td align="right">
          <label for="title">搜索地址：</label>
        </td>
        <td>
          <el-autocomplete id="title" class="inline-input" v-model="data.addressDetail" :fetch-suggestions="querySearch"
            placeholder="请输入内容" :trigger-on-focus="false" value-key="title" @select="handleSelect"></el-autocomplete>
        </td>
      </tr>
      <tr>
        <td align="right">
          <label for="content" class="content-label">标题：</label>
        </td>
        <td>
          <input id="content" v-model="data.title" />
        </td>
      </tr>
    </table>
    <!-- <el-dialog
      title="选择地址"
      :visible.sync="dialogShow"
      width="800px"
      :close-on-click-modal="false"
      @close="handlerDialogClose">
      <iframe id="mapPage" width="100%" height="600px" frameborder="0"
              src="https://apis.map.qq.com/tools/locpicker?search=1&type=1&key=MKGBZ-ABLHU-NUTV4-GOMAR-IXY4Q-DHBPA&referer=myapp">
      </iframe>
    </el-dialog> -->
  </div>
</template>
<script>
import api from '../../api/index'
let currentSelected = null
export default {
  name: 'AddressSetting',
  props: {
    data: Object
  },
  data: function () {
    return {
      dialogShow: false
    }
  },
  mounted: function () {
    // window.addEventListener(
    //   'message',
    //   event => {
    //     let loc = event.data
    //     if (
    //       loc &&
    //       loc.module === 'locationPicker' &&
    //       currentSelected === this
    //     ) {
    //       this.data.lat = loc.latlng.lat
    //       this.data.lng = loc.latlng.lng
    //       this.data.addressDetail = loc.poiaddress
    //       this.dialogShow = false
    //     }
    //   },
    //   false
    // )
  },
  destroyed: function () {
    console.log('destroyed')
  },
  methods: {
    async querySearch (queryString, cb) {
      console.log('输入了什么', queryString)
      try {
        const response = await api.get(`/applet/get_map?address=${queryString}`)
        console.log('请求所有数据:', response)

        // 调用 callback 返回建议列表的数据
        cb(response.data)
      } catch (error) {
        console.error('Error sending data:', error)
      }
    },
    createFilter (queryString) {
      return (restaurant) => {
        return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
      }
    },
    handleSelect (item) {
      console.log(item)
      this.data.title = item.title
      this.data.items = item
    },
    handleSelectBtnClick: function () {
      this.dialogShow = true
      currentSelected = this
    },
    handlerDialogClose: function () {
      currentSelected = null
    }
  }
}
</script>
<style scoped>
label {
  font-size: 13px;
}

.content-label {
  vertical-align: top;
}

.box {
  padding-top: 20px;
}

table {
  margin: 0 auto;
}

#title {
  width: 320px;
  margin-bottom: 5px;
}

#content {
  width: 320px;
}

tr {
  height: 60px;
}
</style>



// WEBPACK FOOTER //
// src/components/address/AddressSetting.vue